export const OUTER_BLOCK_ELEMENTS = ['BLOCKQUOTE', 'PRE', 'TD'];
export const NEWLINE_BLOCK_ELEMENTS = ['TABLE', 'BLOCKQUOTE', 'PRE'];